import { bulkCreateRunTitle } from '../../../runResults.utils';
import { isTerminal } from '../../../taskModel';
import { timeAgo } from '../taskTimeAgo.utils';
const SEPARATOR = ' · ';
export function bulkCreateTitle(task, texts) {
    return bulkCreateRunTitle(task.jobName, texts);
}
export function bulkCreateSubtitle(task, texts) {
    if (!isTerminal(task.status)) return texts.progressSubtitle({
        created: task.succeeded,
        total: task.total
    });
    if (task.status === 'cancelled') return texts.cancelledSubtitle({
        created: task.succeeded,
        total: task.total
    });
    if (task.status === 'failed') return [
        texts.failedRun(),
        timeAgo(task.updatedAt)
    ].join(SEPARATOR);
    return [
        texts.createdCount({
            created: task.succeeded
        }),
        task.failed > 0 ? texts.failedCount({
            failed: task.failed
        }) : null,
        task.jobName,
        timeAgo(task.updatedAt)
    ].filter((part)=>part != null).join(SEPARATOR);
}
